import { Component, OnInit } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { HeaderService } from "@rubbl-layout";

@Component({
  selector: "app-careers",
  templateUrl: "./careers.component.html",
  styleUrls: ["./careers.component.scss"],
})
export class CareersComponent implements OnInit {
  marketingCards: any = [
    {
      iconClass: "icon-key",
      title: "Key player",
      body: "As a crucial member, you will play a pivotal role in driving Rubbl towards its ambitious goals and accelerating our growth trajectory. ",
    },
    {
      iconClass: "icon-earnings",
      title: "Sales expert",
      body: "You'll have the opportunity to leverage your sales expertise to foster meaningful client relationships and contribute directly to our success.",
    },
    {
      iconClass: "icon-listing",
      title: "Growth potential",
      body: "Join us in shaping the future of Rubbl and unlocking exciting opportunities for personal and professional development.",
    },
  ];

  constructor(private titleService: Title, private meta: Meta, private headerService: HeaderService) {
    this.titleService.setTitle("Jobs | Rubbl");
    this.meta.addTag({ name: "description", content: "Rubbl is expanding and wants to hire you!" });
  }

  ngOnInit(): void {
    this.headerService.showDefaultHeaderItems();
  }
}
